import { useSelector } from "store";
// material-ui
import { useTheme } from "@mui/material/styles";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";

// project imports
import LogoSection from "../LogoSection";
import ThemeSection from "./ThemeSection";
import MobileSection from "./MobileSection";
import ProfileSection from "./ProfileSection";
import LocalizationSection from "./LocalizationSection";
import FullScreenSection from "./FullScreenSection";

import {
  handlerDrawerOpen,
  useGetMenuMaster,
} from "shared/hooks/useGetMenuMaster";

// assets
import { IconMenu2 } from "@tabler/icons-react";

// types
import { MenuOrientation, ThemeMode } from "shared/types/config";


const Header = () => {
  const theme = useTheme();
  const downMD = useMediaQuery(theme.breakpoints.down("md"));

  const { mode, menuOrientation } = useSelector((state) => state.config);
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;
  const isHorizontal =
    menuOrientation === MenuOrientation.HORIZONTAL && !downMD;

  return (
    <>
      {/* logo & toggler button */}
      <Box sx={{ width: downMD ? "auto" : 228, display: "flex" }}>
        {!isHorizontal && (
          <Avatar
            variant='rounded'
            sx={{
              ...theme.typography.commonAvatar,
              ...theme.typography.mediumAvatar,
              overflow: "hidden",
              transition: "all .2s ease-in-out",
              bgcolor:
                mode === ThemeMode.DARK ? "dark.main" : "secondary.light",
              color:
                mode === ThemeMode.DARK ? "secondary.main" : "secondary.dark",
              "&:hover": {
                bgcolor:
                  mode === ThemeMode.DARK ? "secondary.main" : "secondary.dark",
                color: mode === ThemeMode.DARK ? "grey.800" : "secondary.light",
              },
              ml: -1,
            }}
            onClick={() => handlerDrawerOpen(!drawerOpen)}
            color='inherit'
          >
            <Box
              sx={{
                width: "20px",
                height: "20px",
                transform: `rotate(${drawerOpen ? "90deg" : 0}) scaleX(${drawerOpen ? 0.2 : 1})`,
                transition: "all .2s ease-in-out",
              }}
            >
              <IconMenu2 stroke={1.5} size='20px' />
            </Box>
          </Avatar>
        )}
        <Box
          component='span'
          sx={{
            display: { xs: "none", md: "block" },
            flexGrow: 1,
            pt: "3px",
          }}
        >
          <LogoSection />
        </Box>
      </Box>

      {/* box spaces */}
      <Box sx={{ flexGrow: 1 }} />
      <Box sx={{ flexGrow: 1 }} />
      {/* theme mode */}

      <Box sx={{ display: { xs: "none", sm: "block" } }}>
        <ThemeSection />
      </Box>

      {/* live customization & localization */}
      <Box sx={{ display: { xs: "none", sm: "block" } }}>
        <LocalizationSection />
      </Box>

      {/* full sceen toggler */}
      <Box sx={{ display: { xs: "none", lg: "block" } }}>
        <FullScreenSection />
      </Box>

      {/* profile */}
      <ProfileSection />

      {/* mobile header */}
      <Box sx={{ display: { xs: "block", sm: "none" } }}>
        <MobileSection />
      </Box>
    </>
  );
};

export default Header;
